import { isRight } from 'fp-ts/lib/Either';
import { BookingIntentResponseCodec } from './bookingIntentCodec';
import type { BookingIntent, BookingIntentProcessFlag } from './types';

const PROCESS_FLAG_STATUS_MAP: Record<BookingIntentProcessFlag, BookingIntent['status']> = {
    D: 'DELIVERED',
    I: 'INVOICED',
    C: 'CANCELED',
    R: 'REVERSED',
};

export class BookingIntentError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'BookingIntentError';
    }
}

export function mapBookingIntentsResponse(apiResponse: unknown): BookingIntent[] {
    const decodedResponse = BookingIntentResponseCodec.decode(apiResponse);

    if (isRight(decodedResponse)) {
        return decodedResponse.right.booking_intents.map(bookingIntent => ({
            operationNumber: bookingIntent.operation_number,
            packageCode: bookingIntent.package_code,
            vin: bookingIntent.vin,
            occurredAt: bookingIntent.occurred_at,
            soldToPartyCountryCode: bookingIntent.sold_to_party_country_code,
            invoicedAt: bookingIntent.invoiced_at,
            deliveredAt: bookingIntent.delivered_at,
            processFlag: bookingIntent.process_flag,
            status: PROCESS_FLAG_STATUS_MAP[bookingIntent.process_flag],
            assets: bookingIntent.assets.map(asset => ({
                assetId: asset.asset_id,
                accountId: asset.account_id,
            })),
        }));
    }

    throw new BookingIntentError(`Invalid booking intent response ${JSON.stringify(apiResponse)}`);
}
